import { action } from 'typesafe-actions';

export interface IAboutDataCounts {
    grantsCount: number;
    projectsCount: number;
    organizationsCount: number;
};

export const enum AboutActionTypes {
  GET_DATA_COUNTS = '@@about/GET_DATA_COUNTS',
  GET_DATA_COUNTS_SUCCESS = '@@about/GET_DATA_COUNTS_SUCCESS',
  GET_DATA_COUNTS_ERROR = '@@about/GET_DATA_COUNTS_ERROR',
};

export const aboutDataCountsRequest = () => {
    return action(AboutActionTypes.GET_DATA_COUNTS);
};

export const aboutDataCountsSuccess = (data: IAboutDataCounts) => {
    return action(AboutActionTypes.GET_DATA_COUNTS_SUCCESS, data);
};

export const aboutDataCountsError = (data: any) => {
    return action(AboutActionTypes.GET_DATA_COUNTS_ERROR, data);
};
